/**
 * Page Javascript
 *
 * - Organise javascript based on current page to
 *   prevent unnecessary searching of the DOM
 */
(function($) {
	$(document).ready(function(){
		switch($("form").attr("action")){

			case "page-frontend-news-signup" :
				//todo: where this?
				$signupForm = $('#signup-form');
				$signupForm.submit(function (e) {
					 e.preventDefault();

					 $.getJSON(
						 this.action + "?callback=?",
						 $(this).serialize(),
						 function (data) {
							 if (data.Status === 400) {
								 alert("Error: " + data.Message);
							 } else { // 200
								 $signupForm.find(".form-fieldset").html("<div class=\"message\">" + data.Message + "</div>");
							 }
						 }
					 );
			 	});


				break;

			/**
			 * REQUEST A QUOTE
			 */
			case "/request-more-info/":

				$(".quoteType input[name='quote_type']").click(function(e) {
					// $("div.mainContent div.middle:first").css("height","auto");

					if ($(this).val() == "zone1") {
						$(".zone2").hide();
						$(".zone1").fadeIn();
					} else if ($(this).val() == "zone2") {
						$(".zone1").hide();
						$(".zone2").fadeIn();
					}

					$(".yourDetails").fadeIn();
					$(".form-action").fadeIn();
					$(".form-message").hide();
				});

				//alert( $(".quoteType input[name='quote_type']:checked").val() );
				$(".quoteType input[name='quote_type']").each(function() {
					if ($(this).attr("checked")) {
						$(this).trigger('click');
					}
				});


				break;

			/**
		     * CONACT US
		     */
			case "/request-a-demo/":
				// Request a Demo Handlers
				$(".bottom").on("click", function(e) {
					e.preventDefault();
					$(this).parent().toggleClass("active");

					var $formInput = $(this).find("input[type='hidden']");
					var moduleName = $formInput.attr("data-module-name");

					var productValue = ($(this).parent().hasClass("active")) ? moduleName : 0;
					$formInput.val(productValue);
				});

				// Contact Google Map
				var $map = $(".widget-office-location-map .map");

				// check map exists and google.maps loaded
				if($map.length && (typeof google === 'object' && typeof google.maps === 'object')){
					// portal address
					var portal_address = portal.address1;
					if(typeof(portal.address2) !== 'undefined' && portal.address2) portal_address += ', ' + portal.address2;
					if(typeof(portal.city) !== 'undefined' && portal.city) 		   portal_address += ', ' + portal.city;
					if(typeof(portal.county) !== 'undefined' && portal.county) 	   portal_address += ', ' + portal.county;
					if(typeof(portal.postcode) !== 'undefined' && portal.postcode) portal_address += ', ' + portal.postcode;
				    if(typeof(portal.country_name) !== 'undefined' && portal.country_name) portal_address += ', ' + portal.country_name;

					// Init Map
					$map.gmap3({
					    marker: {
					        values: [{
					            latLng: [portal.latitude, portal.longitude],
					            data: '<b>' + portal.name + '</b><br /><br />' + portal_address
					        }],
					        options: {
					            draggable: false
					        },
					        events: {
					            mousedown: function (marker, event, context) {
					                var map = $(this).gmap3("get"),
					                    infowindow = $(this).gmap3({
					                        get: {
					                            name: "infowindow"
					                        }
					                    });
					                if (infowindow) {
					                    infowindow.open(map, marker);
					                    infowindow.setContent(context.data);
					                } else {
					                    $(this).gmap3({
					                        infowindow: {
					                            anchor: marker,
					                            options: {
					                                content: context.data
					                            }
					                        }
					                    });
					                }
					            }
					        }
					    },
					    map: {
					        options: {
					            center: [portal.latitude, portal.longitude],
					            zoom: 16,
					            mapTypeId: google.maps.MapTypeId.HYBRID,
					            mapTypeControl: true,
					            mapTypeControlOptions: {
					            	style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
					            },
					            navigationControl: true,
					            scrollwheel: true,
					            streetViewControl: true
					        }
					   }
					});

				} // google.maps loaded

			break;

		} // end switch
	});
})(jQuery);
